import { render, staticRenderFns } from "./ButtonModel.vue?vue&type=template&id=5b4a47bf&scoped=true"
import script from "./ButtonModel.vue?vue&type=script&lang=js"
export * from "./ButtonModel.vue?vue&type=script&lang=js"
import style0 from "./ButtonModel.vue?vue&type=style&index=0&id=5b4a47bf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4a47bf",
  null
  
)

export default component.exports